import { Stack } from "@mui/material";
import { NotificationType } from "constants/NotificationConstants";
import "./UnreadNotificationsNumber.scss";

type Props = {
  notificationType: NotificationType;
  nbUnreadNotifications: number;
};

const UnreadNotificationsNumber: React.FC<Props> = ({
  notificationType,
  nbUnreadNotifications,
}) => {
  if (nbUnreadNotifications > 0)
    return (
      <Stack className={`unread-notification-number ${notificationType}`}>
        {`${nbUnreadNotifications}`}
      </Stack>
    );
  else return null;
};
export default UnreadNotificationsNumber;
